import { render, staticRenderFns } from "./index.vue?vue&type=template&id=09293f86&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=09293f86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09293f86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09293f86')) {
      api.createRecord('09293f86', component.options)
    } else {
      api.reload('09293f86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=09293f86&scoped=true&", function () {
      api.rerender('09293f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/crash/historyDetail/components/ui-game-info/index.vue"
export default component.exports